import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { BusinesscoItem, LogisticService, StockplaceItem } from '../../../services/logistic.service';
import { Item } from '../../../core/components/listbox/listbox.component';

@Component({
  selector: 'tt-requisitions-between',
  templateUrl: './requisitions-between.component.html',
  styleUrls: ['./requisitions-between.component.css']
})
export class RequisitionsBetweenComponent implements OnInit {
    public selectedBgRequisitionsBetweenListType: string = 'NEW';

    public setting?: Setting;

    public selectListCompanies: BusinesscoItem[] = [];

    public selectListStockPlaces: StockplaceItem[] = [];

    public itemsListRequisitionsBetween: Item[] = [];

    public itemsListRequisitionsBetweenConsignment: Item[] = [];

    constructor(private datatask: DataTaskService, private logistic: LogisticService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(766))[0];
    }

    private async loadCompanies() {
        this.selectListCompanies = await this.logistic.getCompanies();
    }

    private async loadStockPlaces() {
        if (!this.setting) return;

        return this.selectListStockPlaces = await this.logistic.getStockplaces({
            businessco_no: this.setting.businessco_no_from,
            add_all: 'ALL'
        });
    }

    private async loadRequisitionsBetween() {
        if (!this.setting) return;

        return this.itemsListRequisitionsBetween = await this.datatask.Post(767, this.setting);
    }

    private async loadRequisitionsBetweenConsignment() {
        if (!this.setting) return;

        return this.itemsListRequisitionsBetweenConsignment = await this.datatask.Post(776, this.setting);
    }

    public onChanged(_: string, id: keyof Setting) {
        if (!this.setting) return;

        switch (id) {
            case 'businessco_no_from':
                Promise.all([
                    this.loadStockPlaces()
                ]).then(() => {
                    this.loadRequisitionsBetween();
                    this.loadRequisitionsBetweenConsignment();
                    Promise.resolve();
                });
                break;
            case 'stockplace_id_from':
                this.loadRequisitionsBetween();
                this.loadRequisitionsBetweenConsignment();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadCompanies();

        return Promise.all([
            this.loadStockPlaces()
        ]).then(() => {
            this.loadRequisitionsBetween();
            this.loadRequisitionsBetweenConsignment();
            Promise.resolve();
        });
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    businessco_no_from: string;
    stockplace_id_from: string;
}
